import { NavLink, Outlet } from "react-router-dom";

import { adminApi, clearSession, type AdminSession } from "../api";

const LINKS: { to: string; label: string }[] = [
  { to: "/", label: "Overview" },
  { to: "/projects", label: "Projects" },
  { to: "/storage", label: "Storage" },
  { to: "/storage-policies", label: "Storage Policies" },
  { to: "/users", label: "Users" },
  { to: "/security-center", label: "Security Center" },
  { to: "/ransomware", label: "Ransomware Defense" },
  { to: "/backup-recovery", label: "Backup & Recovery" },
  { to: "/infrastructure", label: "Infrastructure" },
  { to: "/cost", label: "Cost" },
  { to: "/keys", label: "Keys" },
  { to: "/audit", label: "Audit Explorer" },
  { to: "/break-glass", label: "🆘 Break Glass" },
];

export function Layout({
  session,
  onSignOut,
}: {
  session: AdminSession;
  onSignOut: () => void;
}): JSX.Element {
  async function handleSignOut(): Promise<void> {
    try {
      await adminApi.post("/admin/auth/logout");
    } catch {
      // Best-effort server-side revoke — the client-side session is cleared
      // either way, so a network hiccup here never traps the operator.
    } finally {
      clearSession();
      onSignOut();
    }
  }

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <h1>AstraSpace Admin</h1>
        <nav>
          {LINKS.map((link) => (
            <NavLink key={link.to} to={link.to} end={link.to === "/"}>
              {link.label}
            </NavLink>
          ))}
        </nav>
        <div className="session-info">
          <span className="email">{session.email}</span>
          <span>Role: {session.adminRole}</span>
          <br />
          <span>Session expires {new Date(session.expiresAt).toLocaleTimeString()}</span>
        </div>
        <div style={{ marginTop: 12, padding: "0 8px" }}>
          <button onClick={() => void handleSignOut()}>Sign out</button>
        </div>
      </aside>
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
